// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"74aa8f3f","149":"4b4979ac","164":"fdeebad1","214":"022e06c8","345":"5c5e0bc8","922":"5e38433b","937":"0de14943"}[chunkId] + ".chunk.js";
};